import { useEffect, useMemo, useState } from "react";
import ProductCard from "@/components/ProductCard";
import { fetchProducts } from "@/lib/api";

const CATEGORIES = [
  { id: "all", label: "All" },
  { id: "kitchen", label: "Kitchen" },
  { id: "game", label: "Game" },
  { id: "care", label: "Care" },
];

export default function ShopPage() {
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts()
      .then((d) => setProducts(d))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => {
    if (filter === "all") return products;
    return products.filter((p) => (p.tags || []).includes(filter));
  }, [products, filter]);

  return (
    <div data-testid="shop-page" className="max-w-[1400px] mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-24">
      <header className="mb-14 max-w-3xl">
        <div className="eyebrow mb-5">The Shop</div>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tight leading-[1.02]">
          A small collection, <span className="italic">made well</span>.
        </h1>
        <p className="mt-6 text-[#2C2421]/75 leading-relaxed text-lg">
          Each piece is built in small numbers, by hand. If something speaks to
          you, take it home — or commission your own.
        </p>
      </header>

      <div className="flex flex-wrap items-center gap-3 mb-12">
        {CATEGORIES.map((c) => (
          <button
            key={c.id}
            data-testid={`filter-${c.id}`}
            onClick={() => setFilter(c.id)}
            className={`text-xs tracking-[0.18em] uppercase px-4 py-2 border transition-colors ${
              filter === c.id
                ? "bg-[#2C2421] text-[#FDFBF7] border-[#2C2421]"
                : "border-[#E5E0D8] text-[#2C2421] hover:border-[#2C2421]"
            }`}
          >
            {c.label}
          </button>
        ))}
        <div className="ml-auto text-sm text-[#6F4E37]">
          {loading ? "Loading…" : `${filtered.length} pieces`}
        </div>
      </div>

      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="aspect-[4/5] bg-[#F5F2EB] animate-pulse" />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {filtered.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
